import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import CtaBand from '../components/CtaBand';
import GuideCard from '../components/GuideCard';
import Layout, { PageHero } from '../components/Layout';
import { GUIDE_CATEGORIES, GUIDES } from '../constants/guides';

export default function GuidesPage() {
  const [params, setParams] = useSearchParams();
  const active = params.get('topic') || 'all';
  const query = params.get('q') || '';

  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    return GUIDES.filter(
      (g) =>
        (active === 'all' || g.category === active) &&
        (!q || `${g.title} ${g.summary}`.toLowerCase().includes(q))
    );
  }, [active, query]);

  const update = (next) => {
    const merged = { topic: active, q: query, ...next };
    const clean = {};
    if (merged.topic && merged.topic !== 'all') clean.topic = merged.topic;
    if (merged.q) clean.q = merged.q;
    setParams(clean, { replace: true });
  };

  return (
    <Layout>
      <PageHero
        eyebrow="Guide library"
        title="Free Ancestry help guides"
        lead="Plain-English, step-by-step help for sign-in, trees, DNA, and app updates."
        crumbs={[{ label: 'Guides' }]}
      />

      <section className="section">
        <div className="container">
          <div className="guide-tools">
            <label className="search-box">
              <span className="sr-only">Search guides</span>
              <input
                type="search"
                value={query}
                placeholder="Search guides — try password, duplicate, or DNA"
                onChange={(e) => update({ q: e.target.value })}
              />
            </label>
            <div className="chips" role="group" aria-label="Filter by topic">
              <button type="button" className={`chip ${active === 'all' ? 'is-active' : ''}`} onClick={() => update({ topic: 'all' })}>
                All topics
              </button>
              {GUIDE_CATEGORIES.map((c) => (
                <button
                  key={c.key}
                  type="button"
                  className={`chip ${active === c.key ? 'is-active' : ''}`}
                  onClick={() => update({ topic: c.key })}
                >
                  {c.label}
                </button>
              ))}
            </div>
          </div>

          {results.length ? (
            <div className="card-grid card-grid--3">
              {results.map((g) => (
                <GuideCard key={g.slug} guide={g} />
              ))}
            </div>
          ) : (
            <p className="empty">No guides match that search yet. Try a different word, or ask us in live chat.</p>
          )}
        </div>
      </section>

      <CtaBand title="Can’t find your answer?" text="Our technicians can help with problems that are not covered here. Open live chat any time." />
    </Layout>
  );
}
